import { EmissaoStatus, RegistroStatus } from 'common/genericTypes';

/** Perfis do usuário logado que podem editar um IF. */
export interface PerfilUsuarioEditar {
  isUsuarioOperacoes: boolean;
  isUsuarioCadastroOperacoes: boolean;
}

/** Exibe o Editar para os perfis Operações e Cadastro de Operações em IF não encerrado. */
export const podeExibirEditar = (perfil: PerfilUsuarioEditar, instrumento: { encerrado?: boolean }): boolean =>
  (perfil.isUsuarioOperacoes || perfil.isUsuarioCadastroOperacoes) && !instrumento.encerrado;

/** Edição ou aditamento aguardando aprovação bloqueia novas ações no IF. */
export const possuiProcessoEmAndamento = (
  registroStatus?: RegistroStatus
): registroStatus is RegistroStatus.AguardandoAprovacaoEdicao | RegistroStatus.AguardandoAprovacaoAditamento =>
  registroStatus === RegistroStatus.AguardandoAprovacaoEdicao ||
  registroStatus === RegistroStatus.AguardandoAprovacaoAditamento;

/** Status mostrado na coluna de status: o processo em andamento tem prioridade sobre o status de emissão. */
export const obterStatusExibido = (instrumento: {
  registro: { status?: RegistroStatus };
  statusEmissao: EmissaoStatus;
}): RegistroStatus | EmissaoStatus =>
  possuiProcessoEmAndamento(instrumento.registro.status) ? instrumento.registro.status : instrumento.statusEmissao;
